module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "calibre1"
  }, [_c('p', {
    staticClass: "calibre7"
  }, [_c('br', {
    staticClass: "calibre9",
    attrs: {
      "id": "calibre_pb_9"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "calibre42"
  }, [_c('span', {
    staticClass: "calibre4"
  }, [_vm._v("Chapter one")])]), _vm._v(" "), _c('p', {
    staticClass: "calibre42"
  }, [_c('span', {
    staticClass: "calibre4"
  }, [_vm._v("I Dare You")])]), _vm._v(" "), _c('p', {
    staticClass: "calibre42"
  }, [_c('span', {
    staticClass: "calibre4"
  })]), _vm._v(" "), _c('p', {
    staticClass: "calibre43"
  }, [_c('span', {
    staticClass: "calibre5"
  })]), _vm._v(" "), _c('p', {
    staticClass: "calibre43"
  }, [_c('span', {
    staticClass: "calibre5"
  }, [_vm._v("     \"I don't give a shit what you say Sully, I am not about to go in there for any amount. You go inside the Mill, you don't come out. Everyone knows that,\" Billy Simms said.")])]), _vm._v(" "), _c('p', {
    staticClass: "calibre43"
  }, [_c('span', {
    staticClass: "calibre5"
  }, [_vm._v("     \"Aw come on Billy, just for five minutes. I tell you what, I will make it ten bucks. TEN BUCKS Billy, you can eat Dairy Queen and get a week’s worth of ICEE'S from U'Totem for that much money,\" Sully Jenkins replied.")])]), _vm._v(" "), _c('p', {
    staticClass: "calibre43"
  }, [_c('span', {
    staticClass: "calibre5"
  }, [_vm._v("     \"Yeah Billy, you could buy all of us ICEE'S for ten bucks and still have enough left over for a steak finger basket,\" Charlie Nolan added.")])]), _vm._v(" "), _c('p', {
    staticClass: "calibre43"
  }, [_c('span', {
    staticClass: "calibre5"
  }, [_vm._v("     \"You want an ICEE, why don't you go inside?\" Billy replied.")])]), _vm._v(" "), _c('p', {
    staticClass: "calibre43"
  }, [_c('span', {
    staticClass: "calibre5"
  }, [_vm._v("     \"What, are you chicken shit?\" Sully asked.")])]), _vm._v(" "), _c('p', {
    staticClass: "calibre43"
  }, [_c('span', {
    staticClass: "calibre5"
  }, [_vm._v("     \"Blow me Sully, I don't see you going in there either,\" Billy added.")])]), _vm._v(" "), _c('p', {
    staticClass: "calibre43"
  }, [_c('span', {
    staticClass: "calibre5"
  }, [_vm._v("     Billy Simms was a normal fifteen year old boy of average height and weight with a blonde crew cut and a laugh like a donkey. His two best friends, Sully Jenkins and Charlie Nolan, were also fifteen. Sully was a bit taller than Billy and sported a nice regular haircut, which looked a lot like the one Timmy wore on \"Lassie.\" Charlie was Billy's size and had a burr haircut, which would look black if it ever grew out, and wore thick black glasses. The three friends had been taking a shortcut to the local Pony League ball park to meet up with whoever else might be there so they could have a pick-up game. ")])]), _vm._v(" "), _c('p', {
    staticClass: "calibre43"
  }, [_c('span', {
    staticClass: "calibre5"
  }, [_vm._v("     The town is Huckster, the state, Illinois, and the year is 1968 in the month of June. Of course this means summer is here and this brings ball games like baseball, football, and basketball. Summer was cool alright. The shortcut to the Pony field saved about ten minutes off the walk, but also had the disadvantage of going by the Faversham Grain K Mill.")])]), _vm._v(" "), _c('p', {
    staticClass: "calibre43"
  }, [_c('span', {
    staticClass: "calibre5"
  }, [_vm._v("     The Faversham Grain Mill had been destroyed back in '36 on June 7th by a fire set by Marty Franks, an employee of the Mill. Today Marty was seven different kinds of pissed off at his boss, Fred Faversham. Apparently the old man didn't take kindly to Marty playing hide the sausage with the gleam in his fatherly eye. ")])]), _vm._v(" "), _c('p', {
    staticClass: "calibre43"
  }, [_c('span', {
    staticClass: "calibre5"
  }, [_vm._v("     Cindy Faversham was the old man’s only daughter and had been seeing young Marty, every week, since they had hooked up at the Walgreens drugstore soda fountain on Christmas Eve. After their cheeseburgers, fries and strawberry shakes, they had parked over towards Mill Road at the dead end and partook of fleshly desires. Now Fred Faversham might not have reacted so angrily save for two reasons; One: Marty worked for him at the Mill as a Mill sweeper and")])]), _vm._v(" "), _c('p', {
    staticClass: "calibre43"
  }, [_c('span', {
    staticClass: "calibre5"
  }, [_vm._v("Two: Cindy was only sixteen years old and Marty was twenty.")])]), _vm._v(" "), _c('p', {
    staticClass: "calibre43"
  }, [_c('span', {
    staticClass: "calibre5"
  }, [_vm._v("     The two lovebirds had been caught in the throes of back seat passion by Clem Johnson, the Mill’s night watchman. Seems Clem had changed his patrol route that night, you know, to mix it up a little. He had parked the truck at the start of Mill Road and then walked the short distance to the dead end with his hound dog 'Rufus.’")])]), _vm._v(" "), _c('p', {
    staticClass: "calibre43"
  }, [_c('span', {
    staticClass: "calibre5"
  }, [_vm._v("     Clem's decision to mix it up a little had gotten him what he asked for alright, gotten it in the form of Marty's butt cheeks bouncing off the back of the driver’s side rear window of his '32 Chevrolet Coupe. Clem was so surprised at seeing ass crack, pumping like a piston in a Peter-built engine that he let out a holler.")])]), _vm._v(" "), _c('p', {
    staticClass: "calibre43"
  }, [_c('span', {
    staticClass: "calibre5"
  }, [_vm._v("     \"Milk my bitchin buttercup!\"")])]), _vm._v(" "), _c('p', {
    staticClass: "calibre43"
  }, [_c('span', {
    staticClass: "calibre5"
  }, [_vm._v("     Yep, the next day Marty was fired on the spot, when he dared to show up for work, by old man Faversham himself. ")])]), _vm._v(" "), _c('p', {
    staticClass: "calibre43"
  }, [_c('span', {
    staticClass: "calibre5"
  }, [_vm._v("     \"You are fired, you little shit, and if I ever see you around here again I will shank your eustis, but good. Now get the hell off my property!\"  ")])]), _vm._v(" "), _c('p', {
    staticClass: "calibre43"
  }, [_c('span', {
    staticClass: "calibre5"
  }, [_vm._v("     Now Marty wasn't what you would call a good loser, nope, not so much. He had only finished tenth grade because his daddy had died from a car accident (that he caused) after a tussle with Jack Black whisky. With no education or ambition, but needing to eat and sleep, Marty set his lofty goals at the only place in town he could get a job, Faversham Mill. ")])]), _vm._v(" "), _c('p', {
    staticClass: "calibre43"
  }, [_c('span', {
    staticClass: "calibre5"
  }, [_vm._v("     With his list of exceptional qualifications he had been able to start at the bottom, two years before, and had still been there until his sexual desires, and bouncing butt cheeks, had gotten said cheeks and the person attached to them, fired. Marty, not having much in his life, was furious and distraught that his whirlwind romance of six months plus had been so thoroughly and completely ended. ")])]), _vm._v(" "), _c('p', {
    staticClass: "calibre43"
  }, [_c('span', {
    staticClass: "calibre5"
  }, [_vm._v("     Cindy Faversham was his one true love and now he had lost her. Well, he certainly wasn't going to let that go unchecked, no sir! He decided that if old man Faversham wanted to ruin their lives then he would ruin old man Favershams' as well. He figured burning down the Mill would put a real hurt on the old man so he decided to do it the next day, in case he lost his nerve. ")])]), _vm._v(" "), _c('p', {
    staticClass: "calibre43"
  }, [_c('span', {
    staticClass: "calibre5"
  }, [_vm._v("     “Hit him where it hurts, in his pocketbook, that's what I'll do,” he thought.")])]), _vm._v(" "), _c('p', {
    staticClass: "calibre43"
  }, [_c('span', {
    staticClass: "calibre5"
  }, [_vm._v("     The next day, Marty got himself a bale of hay and two gallons of gas. He wanted to make sure the job was done right. He waited until nightfall, when everyone had gone home, and snuck in by the south gate. There was a man size hole that had been there forever, as far as Marty knew. ")])]), _vm._v(" "), _c('p', {
    staticClass: "calibre43"
  }, [_c('span', {
    staticClass: "calibre5"
  }, [_vm._v("     The Mill itself was 150 feet tall and resembled a castle, without battlements or a moat. It was made of sand colored stone that rose up and up until ending at the top, where the offices were located. There were three large windows, facing east, which could be seen from a mile away. If Marty had been a more educated man he might have used the word \"MONOLITH\" to describe it. ")])]), _vm._v(" "), _c('p', {
    staticClass: "calibre43"
  }, [_c('span', {
    staticClass: "calibre5"
  }, [_vm._v("     The only way to get to the top was to use the original stairs that wound around the southwest corner of the interior or the elevator in the northwest side of the interior. The elevator had a steel box which could hold up to five men with a weight limit of 1200 pounds. ")])]), _vm._v(" "), _c('p', {
    staticClass: "calibre43"
  }, [_c('span', {
    staticClass: "calibre5"
  }, [_vm._v("     The elevator was painted green, had a fence grate around it and made a hell of a racket going up and even more coming down. The bottom floor held the separators, aspirators and grinders needed to Mill grain. ")])]), _vm._v(" "), _c('p', {
    staticClass: "calibre43"
  }, [_c('span', {
    staticClass: "calibre5"
  }, [_vm._v("     Marty knew the best way to start a fire would be to put the hay around the Mill equipment and directly in the silo. Everyone would be gone so no one would get hurt... unless that stupid son of a bitch Clem tried to be a hero. ")])]), _vm._v(" "), _c('p', {
    staticClass: "calibre43"
  }, [_c('span', {
    staticClass: "calibre5"
  }, [_vm._v("     Marty was extra pissed because tonight was Cindy's birthday and she had promised him he would be the one to put out the candles on her birthday suit cake. Now he figured to just burn down the Mill and get the hell out of town. ")])]), _vm._v(" "), _c('p', {
    staticClass: "calibre43"
  }, [_c('span', {
    staticClass: "calibre5"
  }, [_vm._v("     After nightfall, Marty drove over to the Mill, found the hole in the gate and slid in pulling the bale of hay with a hook in one hand and a two gallon can of gas in the other. After ten minutes of dragging the hay, Marty finally reached the side entrance of the building. Had he gone in the front entrance he might have noticed light coming from the windows at the top of the structure.")])]), _vm._v(" "), _c('p', {
    staticClass: "calibre43"
  }, [_c('span', {
    staticClass: "calibre5"
  }, [_vm._v("     Marty might not have the intellect to figure out Little Orphan Annie's secret code without a decoder ring but he knew enough to get this particular job done fast. He quickly started spreading the hay around the machinery and in the silo itself and, as an added touch, put some in the elevator box and on the stairs. Satisfied he had enough kindling in strategic places, he then picked up the can and began throwing gas all over the hay and equipment until the can was empty. Marty then grabbed his box of matches, pulled one out and slid the tip across the sandpaper side of the box watching it erupt into flame. ")])]), _vm._v(" "), _c('p', {
    staticClass: "calibre43"
  }, [_c('span', {
    staticClass: "calibre5"
  }, [_vm._v("     \"Fuck you Faversham,\" Marty said softly.")])]), _vm._v(" "), _c('p', {
    staticClass: "calibre43"
  }, [_c('span', {
    staticClass: "calibre5"
  }, [_vm._v("     He tossed the match on the nearest pile of hay...")])]), _vm._v(" "), _c('p', {
    staticClass: "calibre43"
  }, [_c('span', {
    staticClass: "calibre5"
  })]), _vm._v(" "), _c('p', {
    staticClass: "calibre42"
  }, [_c('span', {
    staticClass: "calibre5"
  }, [_vm._v("--------------------<>--------------------")])]), _vm._v(" "), _c('p', {
    staticClass: "calibre43"
  }, [_c('span', {
    staticClass: "calibre5"
  })]), _vm._v(" "), _c('p', {
    staticClass: "calibre43"
  }, [_c('span', {
    staticClass: "calibre5"
  }, [_vm._v("     Meanwhile, up in the office at the top of the building, Fred Faversham raised his beer bottle in a toast to his only daughter.")])]), _vm._v(" "), _c('p', {
    staticClass: "calibre43"
  }, [_c('span', {
    staticClass: "calibre5"
  }, [_vm._v("     \"Happy Birthday to Cindy, who may be lacking in judgement, but is still my daughter. I wish you better choices and a fantastic year!\"")])]), _vm._v(" "), _c('p', {
    staticClass: "calibre43"
  }, [_c('span', {
    staticClass: "calibre5"
  }, [_vm._v("     \"Happy Birthday to Cindy!\" ")])]), _vm._v(" "), _c('p', {
    staticClass: "calibre43"
  }, [_c('span', {
    staticClass: "calibre5"
  }, [_vm._v("     The reply was from the others who were in the office which included Cindy's mom, Elaine, five of Cindy's school friends, Franks brother Jerry and his wife Louise along with Clem Johnson.")])]), _vm._v(" "), _c('p', {
    staticClass: "calibre43"
  }, [_c('span', {
    staticClass: "calibre5"
  }, [_vm._v("\"Blow out the candles sweetheart,\" Elaine said.")])]), _vm._v(" "), _c('p', {
    staticClass: "calibre43"
  }, [_c('span', {
    staticClass: "calibre5"
  }, [_vm._v("     Cindy smiled, because she was expected to, bent over and blew out seventeen candles. Everyone clapped and hoot and hollered until Jerry, suddenly, looked confused.")])]), _vm._v(" "), _c('p', {
    staticClass: "calibre43"
  }, [_c('span', {
    staticClass: "calibre5"
  }, [_vm._v("     \"What is it Jerry?\" Fred asked.")])]), _vm._v(" "), _c('p', {
    staticClass: "calibre43"
  }, [_c('span', {
    staticClass: "calibre5"
  }, [_vm._v("     \"I smell kerosene and smoke,\" Jerry replied.")])]), _vm._v(" "), _c('p', {
    staticClass: "calibre43"
  }, [_c('span', {
    staticClass: "calibre5"
  }, [_vm._v("     The fire blazed almost instantly after Marty tossed the match on the hay. Marty was pleased.")])]), _vm._v(" "), _c('p', {
    staticClass: "calibre43"
  }, [_c('span', {
    staticClass: "calibre5"
  }, [_vm._v("     “This will show that son of a bitch he can't just ruin other people's lives,” Marty thought.")])]), _vm._v(" "), _c('p', {
    staticClass: "calibre43"
  }, [_c('span', {
    staticClass: "calibre5"
  }, [_vm._v("     He found he was surprised at how quickly the fire had spread, especially on the stairs. It had already climbed three quarters of the way up and the elevator box was consumed as well. Marty decided he better skedaddle now before the fire blocked his escape. As he was heading towards the door he heard a scream. He heard Cindy scream. She was up in the office.")])]), _vm._v(" "), _c('p', {
    staticClass: "calibre43"
  }, [_c('span', {
    staticClass: "calibre5"
  }, [_vm._v("     Marty froze, he was trying to get his head around the fact that his one true love was trapped five stories up with no way out. He stood transfixed and overwhelmed by the reality of what was happening as he heard many screams coming from above.")])]), _vm._v(" "), _c('p', {
    staticClass: "calibre43"
  }, [_c('span', {
    staticClass: "calibre5"
  })]), _vm._v(" "), _c('p', {
    staticClass: "calibre42"
  }, [_c('span', {
    staticClass: "calibre5"
  }, [_vm._v("--------------------<>--------------------")])]), _vm._v(" "), _c('p', {
    staticClass: "calibre43"
  }, [_c('span', {
    staticClass: "calibre5"
  })]), _vm._v(" "), _c('p', {
    staticClass: "calibre43"
  }, [_c('span', {
    staticClass: "calibre5"
  }, [_vm._v("     \"The fires coming up the stairs,” Tommy Jenkins exclaimed.")])]), _vm._v(" "), _c('p', {
    staticClass: "calibre43"
  }, [_c('span', {
    staticClass: "calibre5"
  }, [_vm._v("     \"Quick, bring up the elevator!\" Fred Faversham hollered.")])]), _vm._v(" "), _c('p', {
    staticClass: "calibre43"
  }, [_c('span', {
    staticClass: "calibre5"
  }, [_vm._v("     \"HELP, HELP!\"")])]), _vm._v(" "), _c('p', {
    staticClass: "calibre43"
  }, [_c('span', {
    staticClass: "calibre5"
  }, [_vm._v("     Cindy was screaming out of the window for help but unfortunately no one was there to hear her screams. After Tommy Jenkins had let everyone know the stairway wasn't an option and Millie Jones had hollered for the elevator to be brought up, Fred had pushed the call button so it would come and get them. ")])]), _vm._v(" "), _c('p', {
    staticClass: "calibre43"
  }, [_c('span', {
    staticClass: "calibre5"
  }, [_vm._v("     Seconds later, the box showed up totally engulfed in flames which quickly spread into the office, ending any hope those inside had of escaping the horror.")])]), _vm._v(" "), _c('p', {
    staticClass: "calibre43"
  }, [_c('span', {
    staticClass: "calibre5"
  }, [_vm._v("     Marty then ran over to the elevator and tried to beat the flame out with a tarp but to no avail. The problem was the tarp itself. It was covered in gas so as soon as the tarp hit the fire it caught fire and so did Marty. His screams then joined the others at the top of the Mill as the flames devoured all in its wake.")])]), _vm._v(" "), _c('p', {
    staticClass: "calibre43"
  }, [_c('span', {
    staticClass: "calibre5"
  })]), _vm._v(" "), _c('p', {
    staticClass: "calibre42"
  }, [_c('span', {
    staticClass: "calibre5"
  }, [_vm._v("--------------------<>--------------------")])]), _vm._v(" "), _c('p', {
    staticClass: "calibre43"
  }, [_c('span', {
    staticClass: "calibre5"
  })]), _vm._v(" "), _c('p', {
    staticClass: "calibre43"
  }, [_c('span', {
    staticClass: "calibre5"
  }, [_vm._v("     \"No, seriously Billy, why don't you go in there first?\" Sully asked again.")])]), _vm._v(" "), _c('p', {
    staticClass: "calibre43"
  }, [_c('span', {
    staticClass: "calibre5"
  }, [_vm._v("     \"Okay, I'll go if you both go with me,\" Billy replied.")])]), _vm._v(" "), _c('p', {
    staticClass: "calibre43"
  }, [_c('span', {
    staticClass: "calibre5"
  }, [_vm._v("     \"No way Jose. Call me chickenshit if you want but no way am I going in there without a Green Beret going in with me,\" Sully answered.")])]), _vm._v(" "), _c('p', {
    staticClass: "calibre43"
  }, [_c('span', {
    staticClass: "calibre5"
  }, [_vm._v("     \"Hey, why don't we get Buster to go with us? He's not afraid of anything,\" Charlie said.")])]), _vm._v(" "), _c('p', {
    staticClass: "calibre43"
  }, [_c('span', {
    staticClass: "calibre5"
  }, [_vm._v("     \"Why do you guys want to go in there so bad anyway?\" Billy asked.")])]), _vm._v(" "), _c('p', {
    staticClass: "calibre43"
  }, [_c('span', {
    staticClass: "calibre5"
  }, [_vm._v("     \"To see if the stories are true of course,\" Sully replied.")])]), _vm._v(" "), _c('p', {
    staticClass: "calibre43"
  }, [_c('span', {
    staticClass: "calibre5"
  }, [_vm._v("     \"What stories?\" Billy asked.")])]), _vm._v(" "), _c('p', {
    staticClass: "calibre43"
  }, [_c('span', {
    staticClass: "calibre5"
  }, [_vm._v("     \"That's right, you haven't lived here long, have you Billy?\" Charlie asked.")])]), _vm._v(" "), _c('p', {
    staticClass: "calibre43"
  }, [_c('span', {
    staticClass: "calibre5"
  }, [_vm._v("     \"Just a few months, but I heard all the stories about the ghosts that haunt the grain Mill. I also heard how three kids have disappeared after going in there.\"")])]), _vm._v(" "), _c('p', {
    staticClass: "calibre43"
  }, [_c('span', {
    staticClass: "calibre5"
  }, [_vm._v("     \"Yeah, the Young brothers, but only the two younger ones never came out. The third brother, the oldest, made it out but he was unable to talk much so they had to send him up to the nut house in Springfield. They had been visiting the Davis's for the summer last year when it happened,\" Charlie said.")])]), _vm._v(" "), _c('p', {
    staticClass: "calibre43"
  }, [_c('span', {
    staticClass: "calibre5"
  }, [_vm._v("     \"What happened to the other two? Did they ever find them?\" Sully asked.")])]), _vm._v(" "), _c('p', {
    staticClass: "calibre43"
  }, [_c('span', {
    staticClass: "calibre5"
  }, [_vm._v("     \"That's the weird part. The older brother, Mark, said they had been running around hollering and acting stupid when Harold, the middle brother suggested they play hide and seek.”")])]), _vm._v(" "), _c('p', {
    staticClass: "calibre43"
  }, [_c('span', {
    staticClass: "calibre5"
  }, [_vm._v("     \"Wait a minute Charlie, how old were they?\" Billy asked.")])]), _vm._v(" "), _c('p', {
    staticClass: "calibre43"
  }, [_c('span', {
    staticClass: "calibre5"
  }, [_vm._v("     \"Uh, I'm not sure. Sully, you remember how old they were?\"")])]), _vm._v(" "), _c('p', {
    staticClass: "calibre43"
  }, [_c('span', {
    staticClass: "calibre5"
  }, [_vm._v("     \"I think Mark was fifteen, Harold was twelve and Lucas was ten,\" Sully replied.")])]), _vm._v(" "), _c('p', {
    staticClass: "calibre43"
  }, [_c('span', {
    staticClass: "calibre5"
  }, [_vm._v("     \"Okay, thanks, go on Charlie,\" Billy stated.")])]), _vm._v(" "), _c('p', {
    staticClass: "calibre43"
  }, [_c('span', {
    staticClass: "calibre5"
  }, [_vm._v("     \"Well, what we heard was Mark agreed to play and was 'it' first. He told his brothers that because the Mill was so big he would count to thirty while they hid. Mark then closed his eyes and counted out to thirty. When he was done, he opened his eyes and went to find the other two. He looked at the charred remains of the Milling machinery. He looked in the old elevator shaft and he looked around the burnt hay bales. After making sure they were not at the ground floor, he decided to go up the stairs to check out the old office spaces. Mark wasn't what you would call chicken shit but he didn't really much want to go up the stairs.\"")])]), _vm._v(" "), _c('p', {
    staticClass: "calibre43"
  }, [_c('span', {
    staticClass: "calibre5"
  }, [_vm._v("     \"Hey you guys, you can come down now. I know you’re up there ‘cause I looked everywhere else,\" Mark called out. ")])]), _vm._v(" "), _c('p', {
    staticClass: "calibre43"
  }, [_c('span', {
    staticClass: "calibre5"
  }, [_vm._v("     -Nothing-")])]), _vm._v(" "), _c('p', {
    staticClass: "calibre43"
  }, [_c('span', {
    staticClass: "calibre5"
  }, [_vm._v("     \"Hey, I said come on down or I will come up there and kick your asses. I swear to Johnson and Johnson I will!\"")])]), _vm._v(" "), _c('p', {
    staticClass: "calibre43"
  }, [_c('span', {
    staticClass: "calibre5"
  }, [_vm._v("     \"Come on up Mark, if you've got the balls to.\"")])]), _vm._v(" "), _c('p', {
    staticClass: "calibre43"
  }, [_c('span', {
    staticClass: "calibre5"
  }, [_vm._v("     Mark was surprised and a little afraid at hearing his younger brother talk to him like that and the voice, the voice sounded weird. It was his brother’s voice but it sounded odd, like someone older was doing a real good imitation of Lucas's voice. ")])]), _vm._v(" "), _c('p', {
    staticClass: "calibre43"
  }, [_c('span', {
    staticClass: "calibre5"
  }, [_vm._v("     \"Alright Lucas, you just made sure you get two Indian burns and a belly slap. Harold, I am giving you one chance to bring Louis down and I might not do the same to you.\"")])]), _vm._v(" "), _c('p', {
    staticClass: "calibre43"
  }, [_c('span', {
    staticClass: "calibre5"
  }, [_vm._v("     -Nothing-")])]), _vm._v(" "), _c('p', {
    staticClass: "calibre43"
  }, [_c('span', {
    staticClass: "calibre5"
  }, [_vm._v("     Mark decided he was being paranoid and went up to the top of the stairs and through the open doorway into the main office space.")])]), _vm._v(" "), _c('p', {
    staticClass: "calibre43"
  }, [_c('span', {
    staticClass: "calibre5"
  }, [_vm._v("     \"When Mark came out of the Mill he was in shock, you know, wild eyed and scared, like that. He walked like those zombie guys in 'Night of the Living Dead.’ When he got to the Davis's house, he just stood in front of it, like a snowman that never melts. His mom comes out and asks what is wrong with him and where are his brothers. Mark just looks right through her as if she isn’t there,” Charlie resumed.")])]), _vm._v(" "), _c('p', {
    staticClass: "calibre43"
  }, [_c('span', {
    staticClass: "calibre5"
  }, [_vm._v("     His mom shakes him.")])]), _vm._v(" "), _c('p', {
    staticClass: "calibre43"
  }, [_c('span', {
    staticClass: "calibre5"
  }, [_vm._v("     -Nothing-")])]), _vm._v(" "), _c('p', {
    staticClass: "calibre43"
  }, [_c('span', {
    staticClass: "calibre5"
  }, [_vm._v("     His mom slaps him.")])]), _vm._v(" "), _c('p', {
    staticClass: "calibre43"
  }, [_c('span', {
    staticClass: "calibre5"
  }, [_vm._v("     -Nothing-")])]), _vm._v(" "), _c('p', {
    staticClass: "calibre43"
  }, [_c('span', {
    staticClass: "calibre5"
  }, [_vm._v("     Mrs. Young calls out for her husband.")])]), _vm._v(" "), _c('p', {
    staticClass: "calibre43"
  }, [_c('span', {
    staticClass: "calibre5"
  }, [_vm._v("     \"CHUCK! CHUCK!\"")])]), _vm._v(" "), _c('p', {
    staticClass: "calibre43"
  }, [_c('span', {
    staticClass: "calibre5"
  }, [_vm._v("     \"WHERE ARE YOUR BROTHERS!\"")])]), _vm._v(" "), _c('p', {
    staticClass: "calibre43"
  }, [_c('span', {
    staticClass: "calibre5"
  }, [_vm._v("     -Nothing-")])]), _vm._v(" "), _c('p', {
    staticClass: "calibre43"
  }, [_c('span', {
    staticClass: "calibre5"
  }, [_vm._v("     \"Hey, hey, what's all the yelling?\" Chuck Young says, as he walked outside with Mitchell and Marlene Davis.")])]), _vm._v(" "), _c('p', {
    staticClass: "calibre43"
  }, [_c('span', {
    staticClass: "calibre5"
  }, [_vm._v("     \"I walked outside and found him just standing here with that look on his face. He won't speak and I don't know where Lucas and Harold are,\" Lisa Young said.")])]), _vm._v(" "), _c('p', {
    staticClass: "calibre14"
  }, [_c('span', {
    staticClass: "calibre5"
  }, [_vm._v("     Chuck goes up to his son, snaps his fingers and yells, \"WHERE ARE YOUR BROTHERS?”")])]), _vm._v(" "), _c('p', {
    staticClass: "calibre14"
  }, [_c('span', {
    staticClass: "calibre5"
  }, [_vm._v("     Mark's face begins to morph from shock to fear, his lips begin to tremble and then...  \"the Mill, the Mill, The Mill, The MILL, THE MILLLLLLLLLLLLLL!”")])]), _vm._v(" "), _c('p', {
    staticClass: "calibre43"
  }, [_c('span', {
    staticClass: "calibre5"
  }, [_vm._v("     \"Well, all the grownups go running for the Mill leaving Mark screaming 'the Mill' over and over,\" Charlie said.")])]), _vm._v(" "), _c('p', {
    staticClass: "calibre43"
  }, [_c('span', {
    staticClass: "calibre5"
  }, [_vm._v("     \"Then what happened?\" Billy asked.")])]), _vm._v(" "), _c('p', {
    staticClass: "calibre43"
  }, [_c('span', {
    staticClass: "calibre5"
  }, [_vm._v("     \"Well, one of the neighbors across the street saw how freaked out Mark was and saw the adults running towards the Mill so they called the police. The cops showed up at the Mill and conducted a thorough search. When everything was said and done, the brothers were nowhere to be found. Nope, not a trace of them anywhere,\" Charlie replied.")])]), _vm._v(" "), _c('p', {
    staticClass: "calibre43"
  }, [_c('span', {
    staticClass: "calibre5"
  }, [_vm._v("      \"So, they never found them?\" ")])]), _vm._v(" "), _c('p', {
    staticClass: "calibre43"
  }, [_c('span', {
    staticClass: "calibre5"
  }, [_vm._v("     \"No, not yet,\" Charlie said.")])]), _vm._v(" "), _c('p', {
    staticClass: "calibre43"
  }, [_c('span', {
    staticClass: "calibre5"
  }, [_vm._v("     \"Has anyone else ever gone in but not come out?\" Billy asked.")])]), _vm._v(" "), _c('p', {
    staticClass: "calibre43"
  }, [_c('span', {
    staticClass: "calibre5"
  }, [_vm._v("     \"Not that can be proven. Folks come round Sheriff Fife's office pretty regular though with pictures of missing persons that were supposed to have travelled through town,\" Sully replied.")])]), _vm._v(" "), _c('p', {
    staticClass: "calibre43"
  }, [_c('span', {
    staticClass: "calibre5"
  }, [_vm._v("     \"When did they put the fence around the property?\" Billy asked.")])]), _vm._v(" "), _c('p', {
    staticClass: "calibre43"
  }, [_c('span', {
    staticClass: "calibre5"
  }, [_vm._v("     \"After the two brothers went missing,\" Charlie said.")])]), _vm._v(" "), _c('p', {
    staticClass: "calibre43"
  }, [_c('span', {
    staticClass: "calibre5"
  }, [_vm._v("     Billy looked thoughtful for a moment and then said, \"I guess the best way to keep from finding out if the Mill is haunted is to not go in there in the first place.\"")])]), _vm._v(" "), _c('p', {
    staticClass: "calibre43"
  }, [_c('span', {
    staticClass: "calibre5"
  }, [_vm._v("     \"Huh? Well that doesn't make any sense. How can you know if it's haunted or not without going in?\" Charlie asked.")])]), _vm._v(" "), _c('p', {
    staticClass: "calibre43"
  }, [_c('span', {
    staticClass: "calibre5"
  }, [_vm._v("     \"Okay, fine butt hole, I will put it another way. The best way not to disappear inside the haunted Mill is to not go in there in the first place,\" Billy answered.")])]), _vm._v(" "), _c('p', {
    staticClass: "calibre43"
  }, [_c('span', {
    staticClass: "calibre5"
  }, [_vm._v("     \"So you are saying that you are for sure chicken shit, right?\" Sully asked.")])]), _vm._v(" "), _c('p', {
    staticClass: "calibre43"
  }, [_c('span', {
    staticClass: "calibre5"
  }, [_vm._v("     \"No, I am saying that I am not stupid enough to go into a place where other kids have gone missing from,\" Billy said.")])]), _vm._v(" "), _c('p', {
    staticClass: "calibre43"
  }, [_c('span', {
    staticClass: "calibre5"
  }, [_vm._v("     \"So you are calling me stupid?\" Sully asked.")])]), _vm._v(" "), _c('p', {
    staticClass: "calibre43"
  }, [_c('span', {
    staticClass: "calibre5"
  }, [_vm._v("     \"Only if you go into the Mill alone. Is that what you are telling me Sully, that you are going into the Mill alone?\" ")])]), _vm._v(" "), _c('p', {
    staticClass: "calibre43"
  }, [_c('span', {
    staticClass: "calibre5"
  }, [_vm._v("     Sully suddenly looked to Charlie to see if maybe he might offer some insightful words to help him out of the jam he appeared to be in.")])]), _vm._v(" "), _c('p', {
    staticClass: "calibre43"
  }, [_c('span', {
    staticClass: "calibre5"
  }, [_vm._v("     Charlie just shrugged his shoulders while keeping a smirk at bay. ")])]), _vm._v(" "), _c('p', {
    staticClass: "calibre43"
  }, [_c('span', {
    staticClass: "calibre5"
  }, [_vm._v("     Billy just kept looking at Sully, arms on hips with head slightly tilted, wearing the raised eyebrows expression which signified \"well?\"")])]), _vm._v(" "), _c('p', {
    staticClass: "calibre43"
  }, [_c('span', {
    staticClass: "calibre5"
  }, [_vm._v("     \"No, that's not what I meant. I meant, I meant... shut up Billy!\"")])]), _vm._v(" "), _c('p', {
    staticClass: "calibre43"
  }, [_c('span', {
    staticClass: "calibre5"
  })]), _vm._v(" "), _c('p', {
    staticClass: "calibre43"
  }, [_c('span', {
    staticClass: "calibre5"
  }, [_vm._v("    The thing about the dwellings that become haunted is that they die, they die along with the creatures who lived and breathed the air that saturated the timber and stone. They absorb the wrong done, they become trapped in time. Suspended in fear and death, they hold hostage the unfortunate ones, who once lived but now cannot heal the ultimate wound of death. Sometimes these spirits that are imprisoned with the dwelling, lash out in anger and retribution, taking the innocent who dare to venture inside and making them new editions to their eternal hell.")])]), _vm._v(" "), _c('p', {
    staticClass: "calibre43"
  }, [_c('span', {
    staticClass: "calibre5"
  }, [_vm._v("     Wouldn't you know it, when Old Man Faversham built the Mill, he had done so on a plot of land that had several large monolithic stones setting haphazardly around in a ragged circle of sorts. All of them were lying on their side save one, which had been sitting smack dab in the middle of the others. If Fred Faversham had read a little more about world cultures and unknown phenomenon, he might have noticed a small resemblance, at least in stone shape, to the group of similar stones in England, at a place called Stonehenge.")])]), _vm._v(" "), _c('p', {
    staticClass: "calibre43"
  }, [_c('span', {
    staticClass: "calibre5"
  }, [_vm._v("     It was the perfect place to build the Mill because for whatever reason nothing would grow for two acres around the stone field (as the locals called it) so the land was worthless to the farmers. As an even better bargain, he had used the monolithic stones to build much of the grain Mill. It had seemed like a win-win situation at the time.")])]), _vm._v(" "), _c('p', {
    staticClass: "calibre43"
  }, [_c('span', {
    staticClass: "calibre5"
  }, [_vm._v("         There was a reason nothing grew around the stones.")])]), _vm._v(" "), _c('p', {
    staticClass: "calibre43"
  }, [_c('span', {
    staticClass: "calibre5"
  })]), _vm._v(" "), _c('p', {
    staticClass: "calibre43"
  }, [_c('span', {
    staticClass: "calibre5"
  })]), _vm._v(" "), _c('p', {
    staticClass: "calibre43"
  }, [_c('span', {
    staticClass: "calibre5"
  })]), _vm._v(" "), _c('p', {
    staticClass: "calibre43"
  }, [_c('span', {
    staticClass: "calibre5"
  })]), _vm._v(" "), _c('p', {
    staticClass: "calibre43"
  }, [_c('span', {
    staticClass: "calibre5"
  })]), _vm._v(" "), _c('p', {
    staticClass: "calibre43"
  }, [_c('span', {
    staticClass: "calibre5"
  })]), _vm._v(" "), _c('p', {
    staticClass: "calibre7"
  }, [_c('span', {
    staticClass: "calibre8",
    attrs: {
      "id": "calibre_pb_10"
    }
  })])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-070456e4","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/text/part0000_split_005.vue
// module id = 75
// module chunks = 0